// import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
import {IChoosed} from '..';
interface StepTwoProps {
  choosed: IChoosed;
  setStepChoosed: React.Dispatch<React.SetStateAction<string | undefined>>;
}
const StepTwo = ({setStepChoosed, choosed}: StepTwoProps) => {
  return (
    <div className="flex flex-col w-full px-2 gap-2 py-2 z-20">
      <div className="flex flex-col w-full gap-2">
        <div className="flex items-center justify-between">
          <span className="text-sm font-Regular">مبلغ پکیج:</span>
          <div className="items-center flex gap-1">
            <span className="text-sm font-Regular">
              {choosed?.discountPrice !== undefined &&
              choosed?.discountPrice !== null
                ? (choosed.discountPrice / 10).toLocaleString()
                : (choosed.price / 10).toLocaleString()}
            </span>
            <span className="text-xs font-Regular">تومان</span>
          </div>
        </div>
      </div>

      <div className="flex w-full border-dashed border-[1px] h-[1px] border-gray-200" />
      <p className="flex bg-gray-50 rounded-[8px] py-1  justify-between items-center text-sm font-Medium px-2">
        <span>مبلغ کل:</span>
        <div className="flex items-center gap-1">
          <span>
            {choosed?.discountPrice !== undefined &&
            choosed?.discountPrice !== null
              ? (choosed?.discountPrice / 10).toLocaleString()
              : (choosed?.price / 10).toLocaleString()}
          </span>
          <span className="text-xs font-Regular">تومان</span>
        </div>
      </p>
      <div className="flex w-full justify-between gap-2">
        <button
          className="bg-farm-shop-500 h-[48px] w-[60%] px-2 rounded-[8px] flex items-center justify-center text-white text-md font-Medium"
          onClick={() => setStepChoosed('StepThree')}
        >
          ادامه و پرداخت
        </button>
        <button
          className="border border-farm-shop-500 text-farm-shop-500 h-[48px] w-[40%] px-2 rounded-[8px] flex items-center justify-center  text-md font-Medium"
          onClick={() => setStepChoosed(undefined)}
        >
          انصراف
        </button>
      </div>
    </div>
  );
};

export default StepTwo;
